export const PQRS_CREATE = "pqrs/PQRS_CREATE";
export const PQRS_CREATE_RESULT = "pqrs/PQRS_CREATE_RESULT";